import { NavLink } from 'react-router-dom';

const ENVS: Array<{ slug: string; label: string }> = [
  { slug: 'test', label: 'TEST' },
  { slug: 'dev', label: 'DEV' },
  { slug: 'uat', label: 'UAT' },
  { slug: 'prod', label: 'PROD' },
];

export default function Nav() {
  return (
    <nav className="app-envnav" aria-label="Environment selector">
      <div className="app-envnav-inner">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
          Overview
        </NavLink>
        {ENVS.map((e) => (
          <NavLink
            key={e.slug}
            to={`/${e.slug}`}
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            {e.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
